// Track if Swiper has been initialized to prevent multiple initializations
let swiperInitialized = false;

// Wrap all Swiper logic in a named function
function initializeSwiperCarousel() {

    if (swiperInitialized) {
        return;
    }

    // Initialize top picks collection carousel
    const swiperElements = document.querySelectorAll(".top-picks-collection-wrapper");
    swiperElements.forEach((el) => {
        const swiperWrapper = el.querySelector(".swiper-wrapper");
        if (!swiperWrapper) return;

        new Swiper(el, {
            slidesPerView: 1.3,
            spaceBetween: 16,
            loop: false,
            navigation: {
                nextEl: el.querySelector(".swiper-button-next"),
                prevEl: el.querySelector(".swiper-button-prev")
            },
            breakpoints: {
                768: {
                    slidesPerView: 2.5,
                },
                1024: {
                    slidesPerView: 4,
                },
                1500: {
                    slidesPerView: 5,
                }
            }
        });
    });

    // Initialize DOTD custom slider
    const dotdSlider = document.querySelector('.dotd-custom-slider');
    if (dotdSlider) {
        new Swiper('.dotd-custom-slider', {
            loop: false,
            slidesPerView: 1.3,
            spaceBetween: 10,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            breakpoints: {
                1024: { slidesPerView: 4, slidesPerGroup: 1, spaceBetween: 16 },
                767: { slidesPerView: 3, slidesPerGroup: 1 },
                480: { slidesPerView: 2, slidesPerGroup: 1 },
            },
            pagination: {
                el: '.dotd-pagination',
                clickable: true,
            },
        });
    }

    // Initialize collections swiper with delay
    const collectionsSwiper = document.querySelector('.collections-swiper');
    if (collectionsSwiper) {
        setTimeout(function () {
            new Swiper('.collections-swiper', {
                slidesPerView: 1.3,
                spaceBetween: 16,
                loop: true,
                autoplay: {
                    delay: 3000,
                    disableOnInteraction: false,
                },
                speed: 500,
                breakpoints: {
                    // When screen width is >= 769px
                    769: {
                        slidesPerView: 5,
                        spaceBetween: 16,
                    },
                },
            });
        }, 300);
    }

    // Initialize custom blog swiper
    const blogSwiper = document.querySelector('.custom-blog-swiper');
    if (blogSwiper) {
        new Swiper('.custom-blog-swiper', {
            loop: false,
            slidesPerView: 1,
            spaceBetween: 10,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            breakpoints: {
                1024: { slidesPerView: 4, slidesPerGroup: 1, spaceBetween: 16 },
                767: { slidesPerView: 3, slidesPerGroup: 1 },
                480: { slidesPerView: 2, slidesPerGroup: 1 },
            },
            pagination: {
                el: '.dotd-pagination',
                clickable: true,
            },
        });
    }

    swiperInitialized = true;
}


function loadScripts(scripts, callback) {
    let loadedCount = 0;
    const totalScripts = scripts.length;

    function onScriptLoad() {
        loadedCount++;
        if (loadedCount === totalScripts) {
            callback();
        }
    }

    scripts.forEach(src => {
        const script = document.createElement("script");
        script.src = src;
        script.onload = onScriptLoad;
        script.onerror = function () {
            console.error(`Failed to load script: ${src}`);
            onScriptLoad(); // Still call callback to prevent hanging
        };
        document.head.appendChild(script);
    });
}

function loadCSS(cssFiles, callback) {
    let loadedCount = 0;
    const totalCSS = cssFiles.length;

    function onCSSLoad() {
        loadedCount++;
        if (loadedCount === totalCSS) {
            if (callback) callback();
        }
    }

    cssFiles.forEach(href => {
        const link = document.createElement("link");
        link.rel = "stylesheet";
        link.href = href;
        link.onload = onCSSLoad;
        link.onerror = function () {
            console.error(`Failed to load CSS: ${href}`);
            onCSSLoad(); // Still call callback to prevent hanging
        };
        document.head.appendChild(link);
    });
}

// Load Swiper script dynamically
function loadSwiperScript(callback) {
    // Check if Swiper is already loaded
    if (typeof Swiper !== "undefined") {
        callback();
        return;
    }

    const cssFiles = [
        "https://cdnjs.cloudflare.com/ajax/libs/Swiper/11.0.5/swiper-bundle.min.css",
        "https://fonts.googleapis.com/css2?family=Outfit:wght@100..900&display=swap",
        "https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;700&display=swap"
    ];

    // Add all your CDN links here
    const scripts = [
        "https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js",
        "https://cdnjs.cloudflare.com/ajax/libs/xlsx/0.18.5/xlsx.full.min.js",
    ];

    loadCSS(cssFiles, function () {
        loadScripts(scripts, callback);
    });
}

// Remove all interaction listeners
function removeInteractionListeners() {
    document.removeEventListener("scroll", onUserInteraction);
    document.removeEventListener("mousemove", onUserInteraction);
    document.removeEventListener("touchstart", onUserInteraction);
    document.removeEventListener("click", onUserInteraction);
    document.removeEventListener("keydown", onUserInteraction);
}

// Trigger on interaction
function onUserInteraction() {
    // Remove all listeners immediately to prevent multiple triggers
    removeInteractionListeners();

    // Load Swiper script and initialize carousel
    loadSwiperScript(initializeSwiperCarousel);
}

// Wait for DOM ready and set up interaction listeners
if (document.readyState === 'loading') {
    document.addEventListener("DOMContentLoaded", setupInteractionListeners);
} else {
    setupInteractionListeners();
}

function setupInteractionListeners() {
    // Add interaction listeners with passive option for better performance
    document.addEventListener("scroll", onUserInteraction, { once: true, passive: true });
    document.addEventListener("mousemove", onUserInteraction, { once: true, passive: true });
    document.addEventListener("touchstart", onUserInteraction, { once: true, passive: true });
    document.addEventListener("click", onUserInteraction, { once: true });
    document.addEventListener("keydown", onUserInteraction, { once: true });
}